export const translationKey = 'jbp-open-elt-form'
